import { render, staticRenderFns } from "./channelDetail.vue?vue&type=template&id=700c6abb&scoped=true"
import script from "./channelDetail.vue?vue&type=script&lang=js"
export * from "./channelDetail.vue?vue&type=script&lang=js"
import style0 from "./channelDetail.vue?vue&type=style&index=0&id=700c6abb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700c6abb",
  null
  
)

export default component.exports